import { z } from 'zod';
import { strictRemoteCodec } from "./remote-codec.js";
export const SearchProviderCatalogSchema = z.object({
    supported: z.boolean(),
    providers: z.array(z.object({ id: z.string().min(1).max(512) }).strict()).max(512),
}).strict();
const contribution = {
    package: 'dsh-github-copilot',
    descriptors: [{
            id: 'dsh-github-copilot:githubCopilotSearchRouting.providers',
            namespace: 'githubCopilotSearchRouting', service: 'githubCopilotSearchRouting', method: 'providers',
            invocation: { kind: 'direct' }, parameters: [],
            result: strictRemoteCodec('dsh-github-copilot#SearchProviderCatalog', SearchProviderCatalogSchema),
        }],
};
export default contribution;
//# sourceMappingURL=search-routing-remote.js.map